import { makeAutoObservable } from "mobx"
import { AxiosResponse } from "axios"

import { notify } from "@src/app/components/notify"
import { paths } from "@src/app/paths"
import { router } from "@src/pages"
import { APIResponse, authApi, catchErrors } from "@src/shared/api"

export class RecoveryStore {
  isLoading = false
  recover = async (identity: { email: string }, reCaptcha: string) => {
    this.isLoading = true

    return authApi
      .recoveryStart({
        ...identity,
        re_captcha: reCaptcha,
      })
      .then((response) => {
        const { data } = response as AxiosResponse<APIResponse>

        router
          .navigate(paths.recoverConfirm)
          .then(() => notify.success(data.message))
      })
      .catch(catchErrors)
      .finally(() => {
        this.isLoading = false
      })
  }
  constructor() {
    makeAutoObservable(this)
  }
}
